import { render } from "./customers-refund.vue?vue&type=template&id=5a903b87"
import script from "./customers-refund.vue?vue&type=script&lang=js"
export * from "./customers-refund.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__